import React from "react";
import { motion } from "framer-motion";
import { ExternalLink, Calendar, Clock, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Badge } from "../GraderUI";

function getStatusVariant(status) {
	if (status === "completed") return "success";
	if (status === "failed") return "destructive";
	return "warning";
}

export default function ReportHeader({
	url,
	createdAt,
	completedAt,
	status,
	backPath = "/aivisibility/audit-list",
	backLabel = "Back to Audit List",
	title = "AEO and GEO Audit Report",
}) {
	const navigate = useNavigate();

	const formatDate = (dateString) => {
		if (!dateString) return "—";
		return new Date(dateString).toLocaleDateString("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		});
	};

	const getDuration = () => {
		if (!completedAt) return null;
		const start = new Date(createdAt).getTime();
		const end = new Date(completedAt).getTime();
		const durationMs = end - start;
		const minutes = Math.floor(durationMs / 60000);
		const seconds = Math.floor((durationMs % 60000) / 1000);
		return `${minutes}m ${seconds}s`;
	};

	const statusLabel = status ? status.charAt(0).toUpperCase() + status.slice(1) : "";

	return (
		<motion.div
			className="report-header"
			initial={{ opacity: 0, y: -20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
		>
			<div className="report-header__container">
				<button
					type="button"
					className="report-header__back"
					onClick={() => navigate(backPath)}
				>
					<ArrowLeft className="report-header__back-icon" />
					<span>{backLabel}</span>
				</button>

				<div className="report-header__row">
					<div className="report-header__main">
						<h1 className="report-header__title">{title}</h1>
						{url && (
							<a
								href={url}
								target="_blank"
								rel="noopener noreferrer"
								className="report-header__url"
							>
								{url}
								<ExternalLink className="report-header__url-icon" />
							</a>
						)}
					</div>
					{status && (
						<Badge variant={getStatusVariant(status)}>{statusLabel}</Badge>
					)}
				</div>

				<div className="report-header__meta">
					<div className="report-header__meta-item">
						<Calendar className="report-header__meta-icon" />
						<span>Created: {formatDate(createdAt)}</span>
					</div>
					{completedAt && (
						<div className="report-header__meta-item">
							<Calendar className="report-header__meta-icon" />
							<span>Completed: {formatDate(completedAt)}</span>
						</div>
					)}
					{getDuration() && (
						<div className="report-header__meta-item">
							<Clock className="report-header__meta-icon" />
							<span>Duration: {getDuration()}</span>
						</div>
					)}
				</div>
			</div>
		</motion.div>
	);
}
